import * as yup from 'yup';
import { fahrzeugSchema } from '@/features/Sparten/pkwv2/schema/fahrzeugSchema/fahrzeugSchema';
import { versicherungsnehmerSchema } from '@/features/Sparten/pkwv2/schema/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { allgemeinKfzSchema } from '@/features/Sparten/shared/schema/kfz/allgemeinSchema/allgemeinSchema';
import { baseInputSchema } from '@/features/Sparten/shared/schema/kfz/baseInputSchema';
import { KASKOTYP } from '@/features/Sparten/shared/types';
import { erstfahrzeugSchema } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugSchema';
import { fahrerkreisSchema as kfzFahrerkreisSchema } from '@/features/Sparten/shared/schema/kfz/fahrerkreisSchema/fahrerkreisSchema';

export const pkwSchema = baseInputSchema.concat(
  yup.object({
    allgemein: allgemeinKfzSchema,
    erstfahrzeug: erstfahrzeugSchema,
    fahrerkreis: kfzFahrerkreisSchema,
    fahrzeug: fahrzeugSchema,
    sfKlasseKH: yup.string().required().default(''),
    sfKlasseVK: yup
      .string()
      .default('')
      .when('kaskoTyp', {
        is: (val: string) => val === 'vollkasko',
        then: yup.string().required(),
      }),
    versicherungsnehmer: versicherungsnehmerSchema,
    fahrerschutzversicherung: yup.boolean().default(false),
    rabattschutzKfzHaftpflicht: yup
      .boolean()
      .default(false)
      .when('kaskoTyp', {
        is: (val: string) => val !== KASKOTYP.VOLLKASKO,
        then: yup.boolean().required(),
      }),
    rabattschutzVollkasko: yup
      .boolean()
      .default(false)
      .when('kaskoTyp', {
        is: (val: string) => val === KASKOTYP.VOLLKASKO,
        then: yup.boolean().required(),
      }),
    // V2-Delta: der pkwv2-BE-Validator fordert eingabedaten.hauptfaelligkeitUnterjaehrig
    // (Required bool) — analog campv2. Als Top-Level-Feld landet es via buildInputDataObject
    // im eingabedaten-Objekt des Tarif-Requests.
    hauptfaelligkeitUnterjaehrig: yup.boolean().default(false),
  }),
);
